export const FETCH = 'FETCH_'
export const FETCHING = 'FETCHING_'
export const FETCHED = 'FETCH_SUCCESS_'
export const FETCH_FAIL = 'FETCH_FAIL_'

export const RECEIVE = 'RECEIVE_'

export const CREATE = 'CREATE_'
export const CREATING = 'CREATING_'
export const CREATED = 'CREATE_SUCCESS_'
export const CREATE_FAIL = 'CREATE_FAIL_'

export const UPDATE = 'UPDATE_'
export const UPDATING = 'UPDATING_'
export const UPDATED = 'UPDATE_SUCCESS_'
export const UPDATE_FAIL = 'UPDATE_FAIL_'

export const DELETE = 'DELETE_'
export const DELETING = 'DELETING_'
export const DELETED = 'DELETE_SUCCESS_'
export const DELETE_FAIL = 'DELETE_FAIL_'

export const ONCE = 'ONCE'
export const NEVER = 'NEVER'
